import dayjs from 'dayjs';
import { DATE_FORMAT } from '../../constants';

/**
 * Parses a calendar date the API sends as "YYYY-MM-DD" (a DateField such as `hire_date`)
 * into a local Date of that same day.
 *
 * Such a date has no time or timezone, so it must not be read as UTC (utcToLocalDate,
 * `new Date("YYYY-MM-DD")`, a string `selected` of react-datepicker): UTC midnight is
 * the evening before anywhere west of UTC, so US users would see the day before.
 *
 * @param {string | Date | null | undefined} date - "YYYY-MM-DD", or a Date already picked.
 * @returns {Date | null}
 */
export const calendarDateToLocalDate = (date) => {
  if (!date) {
    return null;
  }

  const parsedDate = dayjs(date);
  return parsedDate.isValid() ? parsedDate.toDate() : null;
};

/**
 * Formats a calendar date ("YYYY-MM-DD") as the same day, see calendarDateToLocalDate.
 *
 * @param {string | Date | null | undefined} date
 * @param {string} [dateFormat=DATE_FORMAT]
 * @returns {string | undefined}
 */
export const formatCalendarDate = (date, dateFormat = DATE_FORMAT) => {
  const localDate = calendarDateToLocalDate(date);
  return localDate ? dayjs(localDate).format(dateFormat) : undefined;
};
